/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react'
import styles from './style.module.scss'
import { Col, Row } from 'react-bootstrap'
import useWindowSize from '@shared/hooks/windowSize'
import CustomLink from '@shared/components/customLink'
import india from '@assets/images/championTrophy/teamFlags/india.png'
import pakistan from '@assets/images/championTrophy/teamFlags/pakistan.png'
import westIndies from '@assets/images/championTrophy/teamFlags/westIndies.svg'
import australia from '@assets/images/championTrophy/teamFlags/australia.png'
import newZealand from '@assets/images/championTrophy/teamFlags/newZealand.png'
import southAfrica from '@assets/images/championTrophy/teamFlags/southAfrica.png'
import MyImage from '@shared/components/myImage'
import { getImgURL } from '@shared-submodule/utils'
// import GoogleAds from '@shared-submodule/sm-components/googleAds'
// import { googleAddData } from '@shared-submodule/sm-constants/googleAdsData'
import { reviveAdData } from '@shared/components/reviveAds/reviveAdData'
import dynamic from 'next/dynamic'

const ReviveAds = dynamic(() => import('@shared/components/reviveAds'), { ssr: false })

const ChampionsTimeline = ({ data, teamData, team }) => {
  const [filter, setFilter] = useState('Group A')
  const [width] = useWindowSize()

  const timelineData = [
    { year: 1998, winner: 'South Africa', bestPlayer: 'Jacques Kallis', winnerType: 'Winner', nationalFLag: southAfrica },
    { year: 2000, winner: 'New Zealand', bestPlayer: 'Not Awarded', winnerType: 'Winner', nationalFLag: newZealand },
    { year: 2002, winner: 'India & SriLanka', bestPlayer: 'Not Awarded', winnerType: 'Joint winner', nationalFLag: india },
    { year: 2004, winner: 'West Indies', bestPlayer: 'R Sarwan', winnerType: 'Winner', nationalFLag: westIndies },
    { year: 2006, winner: 'Australia', bestPlayer: 'Chris Gayle', winnerType: 'Winner', nationalFLag: australia },
    { year: 2009, winner: 'Australia', bestPlayer: 'Ricky Ponting', winnerType: 'Winner', nationalFLag: australia },
    { year: 2013, winner: 'India', bestPlayer: 'Shikhar Dhawan', winnerType: 'Winner', nationalFLag: india },
    { year: 2017, winner: 'Pakistan', bestPlayer: 'Hassan Ali', winnerType: 'Winner', nationalFLag: pakistan }
  ]

  const { addTop } = reviveAdData

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>Previous Winners </h2>
      <div className={`${styles.timeline} scroll-list`}>
        {timelineData?.map((d, i) => (
          <div key={d.year} className={styles.dateColumn}>
            <div className={`${styles.dateNode}`}>
              <span />
            </div>
            <div className={`${styles.dateLabel}`}>{d?.year}</div>
            <div className={styles.matches}>
              <div className={styles.match}>
                <div
                  className={`${styles.teamLogos} ${
                    d?.season === 2024 ? 'justify-content-center text-center' : 'justify-content-center gap-2 text-start'
                  }`}>
                  {d?.season !== 2024 && (
                    <div className={`${styles.team} w-full d-flex text-center align-items-center flex-column w-75`}>
                      <MyImage src={d?.nationalFLag} alt="Continental Kings" height={35} width={45} />
                    </div>
                  )}

                  <div className="d-flex flex-column align-items-center w-100">
                    <span className={styles.teamTitle}>{d?.year === '2025' ? 'TBA' : d?.winner}</span>
                    <span className={styles.vsText}>{`Winner, ${d.year}`} </span>
                  </div>
                </div>
                <div className={`${styles.matchDetail} text-center p-2`}>
                  <div className={styles.matchTime}>
                    <div className={styles.timeTitle}>Season</div>
                    <div className={styles.timeValue}>{d?.year}</div>
                  </div>
                  <div className={styles.separator}></div>
                  <div className={styles.matchTimePlayer}>
                    <div className={styles.timeTitle}>Best Player</div>
                    <div className={styles.timeValue}>{d?.year === '2025' ? 'TBD' : d?.bestPlayer}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {width > 767 && (
        <>
          <div className="p-4">
            <div className="w-full d-none d-xl-flex justify-content-center ">
              {/* <GoogleAds
                addId={googleAddData?.addTop?.addId}
                divId={'div-gpt-ad-1726652608873-0'}
                dimension={googleAddData?.addTop?.dimension}
                slotId={googleAddData?.addTop?.slotId}
                className={'mb-4'}
              />
            </div>
            <div className="d-flex justify-content-between align-items-center w-100">
              <h2 className={`${styles.title} mt-0`}>Teams</h2>
              {/* <div className={styles.filterContainer}>
                <button
                  className={`${styles.filterButton} ${filter === 'Group A' ? styles.activeFilter : ''}`}
                  onClick={() => setFilter('Group A')}>
                  Group A
                </button>
                <button
                  className={`${styles.filterButton} ${filter === 'Group B' ? styles.activeFilter : ''}`}
                  onClick={() => setFilter('Group B')}>
                  Group B
                </button>
              </div> */}
            </div>
            <div>
              <Row>
                {team?.map((a, i) => {
                  return (
                    <Col key={i} lg={3} sm={6}>
                      <Col>
                        <CustomLink href={a?.oSeo?.sSlug}>
                          <a>
                            <div className={`${styles.teamContainer} cursor-pointer`}>
                              <MyImage src={getImgURL(a?.oImg?.sUrl)} height={150} width={150} />
                            </div>
                            <h6 className={`${styles.teamName} cursor-pointer`}>{a?.sTitle || ''}</h6>
                          </a>
                        </CustomLink>
                      </Col>
                    </Col>
                  )
                })}
              </Row>
            </div>
          </div>
        </>
      )}
    </div>
  )
}

export default ChampionsTimeline
